// Assistant.tsx — "recommended next actions" rail card (Sprint 83, ADR-082).
// Port of the prototype's Assistant (home_sf.jsx). Items are passed in by the
// role home; on the Owner home they are derived from REAL signals (overdue
// balance, open requests) where available, with clearly-marked fallbacks.
import React from 'react';
import { ThunderboltOutlined } from '@ant-design/icons';
import { RailCard } from './RailCard';

export type AssistantTone = 'red' | 'amber' | 'blue' | 'green' | 'violet';

export interface AssistantItem {
  /** Headline. */
  h: React.ReactNode;
  /** Sub-line. */
  s: React.ReactNode;
  tone?: AssistantTone;
  /** Right-aligned action label, e.g. "Review". */
  action?: string;
  /** Optional click handler for the action. */
  onAction?: () => void;
}

const TONE: Record<AssistantTone, string> = {
  red: 'var(--red)',
  amber: 'var(--amber)',
  blue: 'var(--blue)',
  green: 'var(--ok)',
  violet: 'var(--violet)',
};

export interface AssistantProps {
  items: AssistantItem[];
}

export const Assistant: React.FC<AssistantProps> = ({ items }) => (
  <RailCard
    icon={<ThunderboltOutlined />}
    tone="linear-gradient(140deg,#6D4AE0,#2563EB)"
    title="Assistant"
    count={items.length}
  >
    {items.length === 0 && <div className="rempty">Nothing needs your attention right now.</div>}
    {items.map((it, i) => (
      <div className="assist-item" key={i}>
        <span className="ad" style={{ background: TONE[it.tone ?? 'blue'] }} />
        <div className="at">
          <div className="h">{it.h}</div>
          <div className="s">{it.s}</div>
        </div>
        <button type="button" className="ago" onClick={it.onAction}>
          {it.action ?? 'View'}
        </button>
      </div>
    ))}
  </RailCard>
);

export default Assistant;
